function SignatureIcon({ fill }: string | any | { fill: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill ? fill : "#2c2c2c"}
        fillRule="evenodd"
        d="M19.178 2c-.748 0-1.466.297-1.995.827l-8.59 8.588a.904.904 0 00-.237.42l-.904 3.617a.904.904 0 001.096 1.096l3.616-.904a.905.905 0 00.42-.238l8.59-8.589A2.822 2.822 0 0019.178 2zm-.717 2.105a1.014 1.014 0 011.434 1.434l-8.412 8.412-1.912.478.478-1.912 8.412-8.412z"
        clipRule="evenodd"
      ></path>
      <path
        fill={fill ? fill : "#2c2c2c"}
        d="M4.712 3.918A2.712 2.712 0 002 6.63v12.658A2.712 2.712 0 004.712 22H17.37a2.713 2.713 0 002.712-2.712v-6.329a.904.904 0 10-1.808 0v6.329a.904.904 0 01-.904.904H4.712a.904.904 0 01-.904-.904V6.63a.904.904 0 01.904-.904h6.33a.904.904 0 000-1.808h-6.33z"
      ></path>
      <path
        stroke={fill ? fill : "#2c2c2c"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.3"
        d="M19.178 2c-.748 0-1.466.297-1.995.827l-8.59 8.588a.904.904 0 00-.237.42l-.904 3.617a.904.904 0 001.096 1.096l3.616-.904a.905.905 0 00.42-.238l8.59-8.589A2.822 2.822 0 0019.178 2zm-.717 2.105a1.014 1.014 0 011.434 1.434l-8.412 8.412-1.912.478.478-1.912 8.412-8.412z"
        clipRule="evenodd"
      ></path>
      <path
        stroke={fill ? fill : "#2c2c2c"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.3"
        d="M4.712 3.918A2.712 2.712 0 002 6.63v12.658A2.712 2.712 0 004.712 22H17.37a2.713 2.713 0 002.712-2.712v-6.329a.904.904 0 10-1.808 0v6.329a.904.904 0 01-.904.904H4.712a.904.904 0 01-.904-.904V6.63a.904.904 0 01.904-.904h6.33a.904.904 0 000-1.808h-6.33z"
      ></path>
    </svg>
  );
}
export default SignatureIcon;
